import styled from "styled-components";
import {MDXEditor} from "@mdxeditor/editor";

export const MyTextEditor = styled(MDXEditor)`
  .mdxeditor-toolbar{
    padding: ${props => props.readOnly ? 0 : `var(--spacing-1_5)`};
  }
  
  .mdxeditor-root-contenteditable{
    & > div{
      padding: ${props => props.readOnly ? 0 : `var(--spacing-3)`};
    }
  }
  
  p{
    margin-bottom: 0 !important;
  }
`